module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_3.5ca138bd.png";